// extracted by mini-css-extract-plugin
module.exports = {"container":"_2G7ZYCu7vAsHG5a84HA1Tp","divider":"JX1KZrsE772L97Ih0YtQb"};